import { render, staticRenderFns } from "./setBalanceDialog.vue?vue&type=template&id=dcd883a4&"
import script from "./setBalanceDialog.vue?vue&type=script&lang=js&"
export * from "./setBalanceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports